import { createEntityAdapter } from '@ngrx/entity';
import { adUserActions } from '../actions';
export const adalUserAdapter = createEntityAdapter({
    selectId: (item) => parseUserEmail(item.userPrincipalName),
    sortComparer: (a, b) => {
        if (a.displayName && b.displayName) {
            return a.displayName.localeCompare(b.displayName);
        }
    }
});
export function parseUserEmail(email) {
    email = email ? email.toLowerCase() : '';
    email = email ? email.replace('mtvn', 'viacom') : '';
    return email;
}
export const INIT_STATE = adalUserAdapter.getInitialState({
    loading: false,
    currentUser: null
});
/**
 * Ngrx reducer for the auth state, this updates the state for the login/logout success actions
 *
 * @export
 * @param [state=INITIAL_STATE]
 * @param action
 * @returns { Auth } Updated state or the default state
 */
export function adUserReducer(state = INIT_STATE, action) {
    switch (action.type) {
        case adUserActions.LOAD_AD_USER: {
            return { ...state, loading: true };
        }
        case adUserActions.LOAD_AD_USER_SUCCESS: {
            return {
                ...adalUserAdapter.addOne(action.payload, state),
                loading: false
            };
        }
        case adUserActions.LOAD_CURRENT_USER_SUCCESS: {
            return {
                ...state,
                currentUser: action.payload
            };
        }
        case adUserActions.LOAD_AD_USER_FAILED: {
            return { ...state, loading: false };
        }
        default: {
            return state;
        }
    }
}
export const getAdUserLoading = (state) => state.loading;
//# sourceMappingURL=ad-user.reducer.js.map